import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useFileAttachmentsLiveInputStore = defineStore(
  'fileAttachmentsLiveInput',
  () => {
    const textPropertyName = ref('')
    const textPropertyObjectId = ref('')

    const setActiveFileElementOptions = (params: {
      textPropertyName: string
      textPropertyObjectId: string
    }): void => {
      textPropertyName.value = params.textPropertyName
      textPropertyObjectId.value = params.textPropertyObjectId
    }

    return {
      textPropertyName,
      textPropertyObjectId,

      setActiveFileElementOptions,
    }
  }
)
